module.exports = __webpack_public_path__ + "static/img/icon-reject.8c89adeb.png";